import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlane = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M23.7333 25.6L21.3333 14.6667L26 10C28 8 28.6667 5.33333 28 4C26.6667 3.33333 24 4 22 6L17.3333 10.6667L6.4 8.26667C5.73333 8.13333 5.2 8.4 4.93333 8.93333L4.53333 9.6C4.26667 10.2667 4.4 10.9333 4.93333 11.3333L12 16L9.33333 20H5.33333L4 21.3333L8 24L10.6667 28L12 26.6667V22.6667L16 20L20.6667 27.0667C21.0667 27.6 21.7333 27.7333 22.4 27.4667L23.0667 27.2C23.6 26.8 23.8667 26.2667 23.7333 25.6Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPlane;
